// Renders an embedded player for YouTube, Vimeo, or direct video file URLs.
function toEmbed(url) {
  const u = (url || "").trim();
  if (!u) return null;
  // YouTube
  const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return { type: "iframe", src: `https://www.youtube.com/embed/${yt[1]}` };
  // Vimeo
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return { type: "iframe", src: `https://player.vimeo.com/video/${vm[1]}` };
  // Direct video file
  if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(u)) return { type: "video", src: u };
  return { type: "link", src: u };
}

export function VideoEmbed({ url, testid = "video-embed" }) {
  const e = toEmbed(url);
  if (!e) return null;
  if (e.type === "iframe") {
    return (
      <div data-testid={testid} className="mt-2 relative w-full rounded-lg overflow-hidden border border-line" style={{ paddingTop: "56.25%" }}>
        <iframe
          src={e.src}
          title="Training video"
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  if (e.type === "video") {
    return <video data-testid={testid} src={e.src} controls className="mt-2 w-full rounded-lg border border-line" />;
  }
  return (
    <a data-testid={testid} href={e.src} target="_blank" rel="noreferrer" className="text-sm text-clinical underline block mt-2">
      ▶ Watch video
    </a>
  );
}
